import React, { useContext } from 'react';
import { quoteStatus } from '../../../../data/quoteStatus';

import {
  ClientContext,
  ExpertContext,
  ProfileContext,
} from '../../../Contexts/contexts';
import ActivityElement from './ActivityElement';

function Activity() {
  const profileContext = useContext(ProfileContext);
  const clientContext = useContext(ClientContext);
  const expertContext = useContext(ExpertContext);

  function getClientActivity() {
    if (!clientContext?.clientExpertRelation) {
      // Vérifie si dans les rejetés, il a donné son avis ou pas
      const unsignedCer = clientContext?.clientExpertRelations?.find(
        (clientExpertRel) => clientExpertRel?.clientSigned === 0
      );

      if (unsignedCer !== undefined) {
        return (
          <ActivityElement
            goTo={`${process.env.REACT_APP_FRONT_BASE_URL}accepted-quotes`}
            type={5}
            role="client"
          />
        );
      }

      // Vérifie si une relation a le statut "en cours d'investigation"
      const investigatedCer = clientContext?.clientExpertRelations?.find(
        (clientExpertRel) =>
          clientExpertRel?.status === quoteStatus.investigation
      );

      if (investigatedCer !== undefined) {
        return (
          <ActivityElement
            goTo={`${process.env.REACT_APP_FRONT_BASE_URL}accepted-quotes`}
            type={6}
            role="client"
          />
        );
      }

      return (
        <ActivityElement
          goTo={`${process.env.REACT_APP_FRONT_BASE_URL}quotes`}
          type={-1}
          role="client"
        />
      );
    }

    if ([0, 1].includes(clientContext?.clientExpertRelation?.status))
      return (
        <ActivityElement
          goTo={`${process.env.REACT_APP_FRONT_BASE_URL}waiting-acceptations`}
          type={clientContext?.clientExpertRelation?.status || 0}
          role="client"
        />
      );

    if ([3].includes(clientContext?.clientExpertRelation?.status)) {
      if ([-1, 1].includes(clientContext?.clientExpertRelation?.clientSigned)) {
        return (
          <ActivityElement
            goTo={`${process.env.REACT_APP_FRONT_BASE_URL}accepted-quotes`}
            type={clientContext?.clientExpertRelation?.status + 1}
            role="client"
            data={clientContext?.clientExpertRelation}
            appointment={getAppointment(
              true,
              clientContext?.clientExpertRelation?.id
            )}
          />
        );
      }
    }

    if ([2, 3, 4].includes(clientContext?.clientExpertRelation?.status))
      return (
        <ActivityElement
          goTo={`${process.env.REACT_APP_FRONT_BASE_URL}accepted-quotes`}
          type={clientContext?.clientExpertRelation?.status}
          role="client"
          data={clientContext?.clientExpertRelation}
          appointment={getAppointment(
            true,
            clientContext?.clientExpertRelation?.id
          )}
        />
      );
  }

  function generateExpertGoTo(clientExpertRelation) {
    let goTo = `${process.env.REACT_APP_FRONT_BASE_URL}`;

    if ([0, 1].includes(clientExpertRelation.status)) {
      goTo += 'waiting-acceptation#' + clientExpertRelation.id;
    } else if ([2].includes(clientExpertRelation.status)) {
      goTo += 'accepted-rdv#' + clientExpertRelation.id;
    } else if (
      clientExpertRelation.status === 3 &&
      clientExpertRelation.expertSigned === 0
    ) {
      goTo += 'accepted-rdv#' + clientExpertRelation.id;
    } else if (
      (clientExpertRelation.status === 3 &&
        clientExpertRelation.expertSigned === 1) ||
      clientExpertRelation.status === 4
    ) {
      goTo += 'payment-quote#' + clientExpertRelation.id;
    }

    return goTo;
  }

  function getExpertActivities() {
    const activities = [];

    expertContext.clientExpertRelations.forEach((clientExpertRelation, idx) => {
      if ([0, 1, 2, 3, 4].includes(clientExpertRelation.status)) {
        let realStatus = clientExpertRelation.status;

        if (realStatus === 3 && clientExpertRelation.expertSigned === 1)
          realStatus++;

        if (
          realStatus >= 4 &&
          clientExpertRelation?.expertCommission?.finishedAt !== null
        )
          return;

        activities.push(
          <ActivityElement
            goTo={generateExpertGoTo(clientExpertRelation)}
            type={realStatus}
            role="expert"
            data={clientExpertRelation}
            key={idx}
            appointment={getAppointment(false, clientExpertRelation.id)}
          />
        );
      }
    });

    return activities;
  }

  function getAppointment(isClient, clientExpertRelationshipId) {
    const context = isClient ? clientContext : expertContext;
    const appointment = context.appointments.filter(
      (item) =>
        item?.clientExpertRelationshipId === clientExpertRelationshipId &&
        item?.acceptedByClient === true &&
        item?.acceptedByExpert === true
    );

    if (appointment.length > 0) return appointment[0];
    else {
      return null;
    }
  }

  return (
    <>
      <div className="activity-container">
        <span className="title">Activités</span>
        {profileContext.isClient && getClientActivity()}
        {profileContext.isExpert && (
          <div className="scrollable-activities">{getExpertActivities()}</div>
        )}
      </div>
    </>
  );
}

export default Activity;
